import { subDays, addDays } from "date-fns";

const VoucherConfigs = {
  master: {
    title: "Voucher",
    apiName: "masterdata/voucher",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: {
      // add_params
      with_payment: 1,
    },
  },
  dialog: {
    title: "Voucher",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
    },
    {
      name: "Code",
      field: "code",
      type: "text_plain",
      table: false,
      filter: true,
      editor: true,
    },
    {
      name: "Payment",
      field: "payment_id",
      type: "object",
      object_name: "data_payment",
      object_field: "name",
      editor: true,
      table: true,
      filter: true,
    },
    {
      name: "Expired Days",
      field: "expired_days",
      table: true,
      filter: true,
      editor: true,
      type: "number_plain",
      align: "right",
    },
    {
      name: "Amount",
      field: "amount",
      type: "number_plain",
      editor: true,
      align: "right",
      table: true,
    },
    {
      name: "Description",
      field: "description",
      type: "text_plain",
      table: false,
      filter: true,
      editor: true,
    },
  ],
};

export default VoucherConfigs;
